import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { INTERNAL_ORG_ID } from '@/constants';
import { userPrivilegeMapQuery } from '@/queries/iam/user-privilege-map-query';

import { useAtlasClient } from './use-atlas-client';
import { useUser } from './use-user';

export const useIsInternalUser = (): boolean => {
  const { userId } = useUser();
  const client = useAtlasClient();

  const { data: userPrivilegeMap } = useQuery(
    userPrivilegeMapQuery({
      userId: userId || '',
      client,
    })
  );

  return useMemo(() => {
    const internalOrgPrivileges = userPrivilegeMap?.get(INTERNAL_ORG_ID);
    return !!internalOrgPrivileges && internalOrgPrivileges.size > 0;
  }, [userPrivilegeMap]);
};
